var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 969,
    height: 684.5,
    viewBox: "0 0 969 684.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-488 -1555)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(521 2156.5)",
    fill: "#484848",
    fontSize: 18,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "- \uD788\uC5B4\uB85C \uB180\uC774\uB294 \uAC00\uB4DC\uB108\uC758 \uB2E4\uC911\uC9C0\uB2A5\uC774\uB860\uC744 \uBC14\uD0D5\uC73C\uB85C 8\uAC00\uC9C0\uC758 \uD575\uC2EC\uC9C0\uD45C\uB97C \uAE30\uBC18\uD558\uC5EC \uAC1C\uBC1C\uD558\uC600\uC73C\uBA70, 5\uAC00\uC9C0\uC758 \uD65C\uB3D9\uC720\uD615\uC73C\uB85C \uBD84\uB958\uB429\uB2C8\uB2E4. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "- \uC790\uCCB4 \uAC1C\uBC1C\uD55C 1000\uAC00\uC9C0\uC758 \uD788\uC5B4\uB85C \uB180\uC774\uBC95\uC744 \uD65C\uC6A9\uD558\uB418 \uC544\uC774\uC8FC\uB3C4 \uB180\uC774\uB97C \uC6D0\uCE59\uC73C\uB85C \uC9C4\uD589\uB429\uB2C8\uB2E4."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "- \uC544\uC774\uC758 \uC5F0\uB839/\uC131\uD5A5 \uBC0F \uBC1C\uB2EC \uB2E8\uACC4\uC5D0 \uB530\uB77C \uB2E4\uB974\uAC8C \uC9C4\uD589\uB429\uB2C8\uB2E4."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "- \uC544\uC774\uC758 \uCEE8\uB514\uC158 \uBC0F \uC0C1\uD669\uC5D0 \uB530\uB77C \uBCC0\uACBD/\uC0DD\uB7B5 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297 1365)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(663 236)",
    fontSize: 40,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -225.92,
    y: 0
  }, "\uC544\uC774\uAC00 \uC790\uB77C\uB098\uB294 \uD2B9\uBCC4\uD55C \uC2DC\uAC04,"), /*#__PURE__*/React.createElement("tspan", {
    x: -91.54,
    y: 55
  }, "\uD788\uC5B4\uB85C \uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.764 -158)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(900.236 2103)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1:1 \uC544\uC774 \uB9DE\uCDA4 \uB180\uC774 \uC9C4\uD589"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.236 -158)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(900.236 2103)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD788\uC5B4\uB85C \uB180\uC774 \uD65C\uB3D9\uC720\uD615"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-382 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1323.367 1738.358)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(18.633 15.642)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.62,
    y: 0
  }, "\uD788\uC5B4\uB85C"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.53,
    y: 18
  }, "\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1264.084 1675.333)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7,0l77.7,56.225L125.721,147.2H29.679L0,56.225Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.69979858398438 2.468704223632812 L 2.353530883789062 56.99028778076172 L 31.12995910644531 145.1979675292969 L 124.2696380615234 145.1979675292969 L 153.0460662841797 56.99026489257812 L 77.69979858398438 2.468704223632812 M 77.69979858398438 0 L 155.3995971679688 56.224609375 L 125.7209014892578 147.1979675292969 L 29.67869567871094 147.1979675292969 L 0 56.22463226318359 L 77.69979858398438 0 Z",
    stroke: "none",
    fill: "#f69f30"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 29.5,
    ry: 30,
    transform: "translate(1312 1647)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 30,
    rx: 30.5,
    ry: 30,
    transform: "translate(1389 1701)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 30,
    rx: 30.5,
    ry: 30,
    transform: "translate(1234 1701)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 30,
    rx: 30.5,
    ry: 30,
    transform: "translate(1261 1790)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 30,
    rx: 30.5,
    ry: 30,
    transform: "translate(1360 1790)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1280.233 1803.086)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(11 14)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 0
  }, "\uC778\uC131"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 15
  }, "\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1379.172 1803.192)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(11 14)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 0
  }, "\uC77C\uC0C1"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 15
  }, "\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1247.609 1715)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(17 14)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.01,
    y: 0
  }, "\uC608\uC220\uAC00 "), /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 15
  }, "\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1325.577 1659.538)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(16 14)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.96,
    y: 0
  }, "\uACFC\uD559\uC790"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 15
  }, "\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404.836 1715)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(16 14)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.96,
    y: 0
  }, "\uBC1C\uBA85\uAC00"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.74,
    y: 15
  }, "\uB180\uC774")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-367.236 -158)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(900.236 2103)",
    fontSize: 20,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD788\uC5B4\uB85C \uB180\uC774 \uD575\uC2EC\uC9C0\uD45C"))), /*#__PURE__*/React.createElement("path", {
    d: "M123.137,0a10,10,0,0,1,7.071,2.929l46.863,46.863A10,10,0,0,1,180,56.863v66.274a10,10,0,0,1-2.929,7.071l-46.863,46.863A10,10,0,0,1,123.137,180H56.863a10,10,0,0,1-7.071-2.929L2.929,130.208A10,10,0,0,1,0,123.137V56.863a10,10,0,0,1,2.929-7.071L49.792,2.929A10,10,0,0,1,56.863,0Z",
    transform: "translate(571.883 1650) rotate(22.5)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(594.519 1641.999)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 16)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC790\uAE30 \uC774\uD574"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(499.811 1677.363)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.189 15.637)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBB38\uC81C\uD574\uACB0"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.92 1757.358)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.08 15.642)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC815\uC11C"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(514.275 1836.907)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-0.275 16.094)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCC3D\uC758\uC131"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.358 1871.306)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 16)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC0AC\uD68C\uC131"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(689.816 1836.907)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.184 16.094)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC2E0\uCCB4"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(724.367 1757.358)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-0.367 15.642)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC5B8\uC5B4"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(689.816 1677.363)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.184 15.637)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBB38\uD654 \uC774\uD574"))), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,0a10,10,0,0,1,7.071,2.929l28.7,28.7A10,10,0,0,1,118,38.7V79.3a10,10,0,0,1-2.929,7.071l-28.7,28.7A10,10,0,0,1,79.3,118H38.7a10,10,0,0,1-7.071-2.929l-28.7-28.7A10,10,0,0,1,0,79.3V38.7a10,10,0,0,1,2.929-7.071l28.7-28.7A10,10,0,0,1,38.7,0Z",
    transform: "translate(589.157 1691) rotate(22.5)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -0.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1165.5-2999.913h198.815",
    transform: "translate(-643 4768)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.5-2999.913h198.815",
    transform: "translate(1848.741 4783.771) rotate(-45)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.5-2999.913h198.815",
    transform: "translate(3621.82 3032.994) rotate(-90)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.5-2999.913h198.815",
    transform: "translate(3637.591 541.253) rotate(-135)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(943 908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.65 803.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5728.75,3345.3c1.458,4.6,2.87,9.051,4.282,13.5.137.437.262.876.425,1.3a2.834,2.834,0,0,0,3.057,1.894c2.87-.3,5.735-.591,8.6-.924.792-.093,1.314-.02,1.487.924.795,4.3,3.281,7.142,7.2,9.155,3.771,1.938,7.259,4.426,10.854,6.7a3.381,3.381,0,0,0,3.942,0c4.907-3.094,9.854-6.124,14.732-9.264a5.139,5.139,0,0,0,1.705-2.144,38.757,38.757,0,0,0,1.625-4.561.988.988,0,0,1,1.269-.83c2.862.335,5.732.6,8.6.918,1.957.218,2.773-.28,3.37-2.156q2.151-6.781,4.3-13.564c.083-.264.179-.527.3-.878a20.838,20.838,0,0,1,9.284,7.23,18.409,18.409,0,0,1,3.487,10.969c-.008,5.735-.014,11.468.017,17.2a1.385,1.385,0,0,1-.759,1.333,90.213,90.213,0,0,1-28.122,11.646,96.261,96.261,0,0,1-31.542,1.98,93.331,93.331,0,0,1-32.262-9.218c-2.736-1.355-5.337-2.98-7.965-4.542a1.559,1.559,0,0,1-.613-1.147c-.037-5.8-.153-11.612,0-17.412C5716.254,3354.7,5721,3349.022,5728.75,3345.3Z",
    transform: "translate(-5715.938 -3270.978)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5767.565,3259.015c-.658,1.444-1.864,1.77-3.217,1.945a23.72,23.72,0,0,1-8.179-.083c-4.433-.961-7.979-3.986-7.687-9.3.033-.62-.267-.825-.728-1.1a39.71,39.71,0,0,1-4.809-3.009c-4.154-3.331-4.053-8.31.123-11.68,1.9-1.534,3.813-3.114,4.644-5.479a18.169,18.169,0,0,0,1.266-5.6c.114-8.357,2.726-15.7,8.575-21.711a29.26,29.26,0,0,1,42.457.247,30.025,30.025,0,0,1,8.5,20.686,13.714,13.714,0,0,0,5.044,10.784,17.6,17.6,0,0,1,1.9,1.824c3.5,4.063,3.557,8.493-1.35,11.85-1.327.907-2.831,1.552-4.216,2.379a1.455,1.455,0,0,0-.712.962c.132,5.4-3.044,8.35-7.682,9.3a23.814,23.814,0,0,1-9.331-.047c-.835-.163-1.532-1.035-2.505-1.733C5782.583,3264.012,5775.14,3264.335,5767.565,3259.015Zm-4.941-37.371c-.117.407-.21.707-.293,1.01a35.942,35.942,0,0,0-1,14.114c.8,6.039,2.812,11.612,7.131,16.115,3.189,3.32,7.041,5.181,11.708,4.681,4.722-.5,8.151-3.243,10.862-6.955a30.026,30.026,0,0,0,5.259-13.637c.181-1.239.461-2.513-.461-3.623a32.573,32.573,0,0,0-2.372-2.813,22.819,22.819,0,0,0-17.339-6.292C5771.473,3224.417,5766.908,3224.042,5762.624,3221.645Z",
    transform: "translate(-5728.12 -3194.001)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5813.624,3354.109c-3.216-.328-6.122-.6-9.02-.933a3.153,3.153,0,0,0-3.694,2.222c-.672,1.811-1.3,3.636-2.034,5.426a3.078,3.078,0,0,1-1.062,1.352c-3.977,2.591-7.992,5.118-11.973,7.7a1.359,1.359,0,0,1-1.711-.007c-3.911-2.492-7.832-4.973-11.792-7.386a3.6,3.6,0,0,1-1.662-2.167c-.53-1.71-1.1-3.407-1.679-5.1a2.875,2.875,0,0,0-3.239-2.076c-2.969.317-5.942.618-8.912.955a.846.846,0,0,1-1.062-.711c-1.186-3.711-2.385-7.418-3.623-11.112-.282-.837.1-.968.771-1.044,2.613-.3,5.263-.465,7.82-1.025a3.353,3.353,0,0,1,3.23.994c4.186,3.486,8.425,6.908,12.646,10.351,1.988,1.621,3.987,3.232,5.972,4.856,1.866,1.527,2.889,1.508,4.753.01,6.494-5.215,13.022-10.389,19.493-15.636,1.123-.909,2.223-.337,3.311-.285,2.1.1,4.193.394,6.288.612.313.032.624.1.938.145.547.08.69.358.514.888-1.242,3.768-2.459,7.543-3.719,11.306A2.047,2.047,0,0,1,5813.624,3354.109Z",
    transform: "translate(-5734.32 -3268.332)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5818.6,3339.418c-4.885,3.937-9.665,7.785-14.531,11.707-4.809-3.871-9.61-7.739-14.533-11.7,1.337-.273,2.516-.547,3.707-.732a2.017,2.017,0,0,1,1.091.232,21.787,21.787,0,0,0,19.429.025,2.839,2.839,0,0,1,1.5-.155C5816.32,3338.934,5817.368,3339.182,5818.6,3339.418Z",
    transform: "translate(-5753.382 -3267.609)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.969 15.615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6122.562,3335.809a5.509,5.509,0,0,1,2.58,3.138c3.551,8.5,7.172,16.976,10.77,25.457.122.292.251.579.437,1,.186-.389.316-.644.428-.91,3.635-8.71,7.295-17.409,10.871-26.144a5.98,5.98,0,0,1,2.3-2.571,15.27,15.27,0,0,0,6.612,1.688c6.938.468,13,6.4,13.351,13.318.229,4.449.1,13.83.108,18.291a1.052,1.052,0,0,1-.459.675,54.873,54.873,0,0,1-18.512,8.736q-25.326,6.376-47.066-8.132a2.566,2.566,0,0,1-1.312-2.531c.1-3.957-.124-12.844.15-16.786.419-6.019,3.643-10.226,9.183-12.554a17.415,17.415,0,0,1,4.434-1.019A15.532,15.532,0,0,0,6122.562,3335.809Z",
    transform: "translate(-6102.663 -3281.75)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6137.743,3230.09a16.372,16.372,0,0,1,13.077,0,23.775,23.775,0,0,1,1.366-2.113c1.62-2.02,3.88-2.352,6.248-2.119,5.808.573,11.342,6.539,11.563,12.376a6.123,6.123,0,0,1-5.352,6.639c-.184.033-.365.091-.638.161a32.236,32.236,0,0,1,1.62,9.852.556.556,0,0,0,.131.03c2.583-.416,4.114.988,3.69,3.559a10.458,10.458,0,0,1-3.361,6.146,3.259,3.259,0,0,1-2.711.885c-1.133,1.966-2.115,3.933-3.339,5.736a20.087,20.087,0,0,1-10.268,8.106,17.3,17.3,0,0,1-16.063-2.369,23.693,23.693,0,0,1-8.112-10.142c-.175-.394-.345-.793-.524-1.186a.749.749,0,0,0-.126-.151,4.191,4.191,0,0,1-3.853-1.916,8.418,8.418,0,0,1-1.949-5.141c-.062-2.874,1.068-3.911,3.888-3.505a29.971,29.971,0,0,1,1.573-9.891c-.569-.135-1.088-.238-1.595-.383a6.053,6.053,0,0,1-4.349-5.481c-.24-4,1.528-7.117,4.3-9.76a11.577,11.577,0,0,1,9.07-3.6,5.985,5.985,0,0,1,5.526,3.953A2.887,2.887,0,0,0,6137.743,3230.09Zm23.142,22.575c-.208-.055-.41-.129-.617-.164a27.823,27.823,0,0,1-14.5-6.919.716.716,0,0,0-.995-.081,30.844,30.844,0,0,1-3,1.614,19.139,19.139,0,0,1-13.131,1.322c-.077.28-.158.535-.218.795a24.406,24.406,0,0,0-.323,8.871c.811,6.047,3.213,11.274,8.2,15.031a13.149,13.149,0,0,0,10.487,2.57,14.822,14.822,0,0,0,9.552-6.079C6160.1,3264.606,6161.284,3258.854,6160.885,3252.665Z",
    transform: "translate(-6110.79 -3225.786)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6164.174,3360.411c-2.323-5.536-4.557-10.866-6.85-16.327a21.753,21.753,0,0,0,13.7,0C6168.739,3349.53,6166.5,3354.861,6164.174,3360.411Z",
    transform: "translate(-6130.475 -3285.973)",
    fill: "#f69f30"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.404 820.676)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(25 16)",
    fill: "#f69f30",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.366,
    y: 0
  }, "1:1"), /*#__PURE__*/React.createElement("tspan", {
    x: -24.71,
    y: 17
  }, "\uB9DE\uCDA4\uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.26 866.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-701.738,1936.453h50.5",
    transform: "translate(708.046 -1928.902)",
    fill: "none",
    stroke: "#f69f30",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H50.5",
    transform: "translate(53.837 25.664) rotate(180)",
    fill: "none",
    stroke: "#f69f30",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26.32a.3.3,0,0,1,.48,0l6.9,9.2a.3.3,0,0,1-.24.48H.6a.3.3,0,0,1-.24-.48Z",
    transform: "translate(-0.26 15.033) rotate(-90)",
    fill: "#f69f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27.277a.3.3,0,0,1,.461,0L14.59,8.508a.3.3,0,0,1-.23.492H.641a.3.3,0,0,1-.23-.492Z",
    transform: "translate(59.74 18.033) rotate(90)",
    fill: "#f69f30"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent2);
export default __webpack_public_path__ + "static/media/content2.71ddaf6a.svg";
export { ForwardRef as ReactComponent };